import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  AutomationEventTypes,
  AutomationTypes,
  AutomationViewGroup,
  DeleteAutomation,
} from '@tokeet-frontend/automations'
import { Template } from '@tokeet-frontend/templates'
import { AutomationsWizardDialogService } from '@tv3/containers/automations/automations-wizard/automations-wizard-dialog.service'
import { ConfirmDialogService, DialogService, isSomething } from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'
import { AutomationExpenseDataDialogComponent } from '@tv3/containers/automations/automation-data-form/expense/dialog/automation-expense-data-dialog.component'
import { filter } from 'rxjs/operators'
import { AutomationIncidentDataDialogComponent } from '@tv3/containers/automations/automation-data-form/incident/dialog/automation-incident-data-dialog.component'
import { ReviewAutomationOverlayComponent } from '@tv3/containers/automations/review/automation-overlay/review-automation-overlay.component'
import { AutomationTaskDataDialogComponent } from '@tv3/containers/automations/automation-data-form/task/dialog/automation-task-data-dialog.component'
import { AutomationLogsDialogService } from '@tv3/containers/automations/automation-logs/dialog/automation-logs-dialog.service'
import { TemplateDialogService } from '@tv3/containers/templates/template-dialog/template-dialog.service'
@Component({
  selector: 'app-autopilot-automation-info',
  templateUrl: './autopilot-automation-info.component.html',
  styleUrls: ['./autopilot-automation-info.component.scss'],
})
export class AutopilotAutomationInfoComponent implements OnInit {
  @Input() automationGroup: AutomationViewGroup
  @Input() eventSourceType: AutomationTypes
  @Input() event: AutomationEventTypes

  //
  @Input() template: Template // message
  @Input() isSendReview = false // review
  @Input() task: any // task
  @Input() hideTaskDateFields = false
  @Input() expense: any // expense
  @Input() incident: any // incident

  @Output() saveData = new EventEmitter<any>()

  dateTimeFormat = `DD-MMM-YYYY • hh:mm A`

  constructor(
    private store: Store<any>,
    private dialog: DialogService,
    private automationsWizardDialog: AutomationsWizardDialogService,
    private confirm: ConfirmDialogService,
    private automationLogsDialog: AutomationLogsDialogService,
    private templateDialogService: TemplateDialogService
  ) {}

  ngOnInit(): void {}

  onConfig() {
    this.automationsWizardDialog.open({
      type: this.eventSourceType,
      event: this.event,
    })
  }

  onLogs() {
    this.automationLogsDialog.open(this.automationGroup)
  }

  onDelete() {
    this.confirm
      .confirm({
        title: $localize`Delete this Automation?`,
        body: $localize`Are you sure you want to delete this automation?`,
      })
      .subscribe(() => {
        this.store.dispatch(DeleteAutomation({ ids: this.automationGroup.ids }))
      })
  }

  onEditExpense() {
    this.dialog
      .openFixedDialog(AutomationExpenseDataDialogComponent, {
        width: '800px',
        data: {
          data: this.automationGroup?.settings?.expense || this.expense,
          event: this.event,
        },
      })
      .afterClosed()
      .pipe(filter(isSomething))
      .subscribe((data) => {
        this.saveData.emit(data)
      })
  }

  onEditIncident() {
    this.dialog
      .openFixedDialog(AutomationIncidentDataDialogComponent, {
        width: '800px',
        data: {
          data: this.automationGroup?.settings?.incident || this.incident,
          event: this.event,
          hideReporterField: true,
        },
      })
      .afterClosed()
      .pipe(filter(isSomething))
      .subscribe((data) => {
        this.saveData.emit(data)
      })
  }

  onEditTask() {
    this.dialog
      .openFixedDialog(AutomationTaskDataDialogComponent, {
        width: '800px',
        data: {
          data: this.automationGroup?.settings?.task || this.task,
          event: this.event,
          hideDateFields: !!this.hideTaskDateFields,
        },
      })
      .afterClosed()
      .pipe(filter(isSomething))
      .subscribe((data) => {
        this.saveData.emit(data)
      })
  }

  onEditReview() {
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
      data: {
        automationGroup: this.automationGroup,
      },
    })
  }

  onEditTemplate() {
    this.templateDialogService.open({ template: this.template, hideType: true, hideTemplates: true })
  }
}
